import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Text, Flex, Heading } from "@chakra-ui/react";

function BookNow() {
  const navigate = useNavigate();

  return (
    <Box
      bgImage={"https://i.ytimg.com/vi/QZbuj3RJcjI/maxresdefault.jpg"}
      py={10}
      textAlign="center"
      paddingBottom={"100px"}
    >
      <Flex direction="column" align="center" justify="center">
        <Heading
          as="h2"
          size="3xl"
          mb={4}
          color="white"
          fontFamily="Sacramento"
        >
          Visit Us Today!
        </Heading>
        <Text fontSize="lg" mb={6} color="white">
          Visit and schedule your appointment today with ease and convenience
        </Text>
        <Button
          as="a"
          href="#"
          size="lg"
          px={10}
          py={6}
          bg="pink.300"
          color="white"
          _hover={{ bg: "pink.600" }}
          onClick={() => {
            navigate("/services");
          }}
        >
          Book Now
        </Button>
      </Flex>
    </Box>
  );
}

export default BookNow;
